/**
 * Returns a function that will create a className, prefixed with `componentName`.
 *
 * The resulting function will join all args provided with "--".
 *
 * @param componentName  The name of the component - eg: "SharedLayout"
 * @param namespace  Your app's SCSS namespace - if using `spa-boilerplate`, this will be `APP_NAME`
 */
export const componentClassName =
  (componentName: string, namespace: string) =>
  (...nodeNames: string[]) =>
    `${namespace}-${componentName}${
      nodeNames.length > 0 ? `--${nodeNames.join("--")}` : ""
    }`;